import { createProfile, parseProfile, type Profile } from '../campaign';
import { readJson, removeKey, writeJson } from './storage';

/** The campaign profile and any run in progress are saved after every change (§16.5). */

const KEY = 'campaign.v1';

export const loadProfile = (): Profile | null => readJson(KEY, parseProfile);

export const saveProfile = (p: Profile): string | null => writeJson(KEY, p);

export const clearProfile = (): void => removeKey(KEY);

export function newProfile(): Profile {
  const seed = `profile-${Date.now().toString(36)}-${Math.floor(Math.random() * 1e9).toString(36)}`;
  return createProfile(seed);
}
